import React from 'react';
import Typography from '@mui/material/Typography';
import AliceCarousel from 'react-alice-carousel';
import "react-alice-carousel/lib/alice-carousel.css";
import DocCard from '../components/DocCard';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Markdown from 'react-markdown';
import { fetchCompanyFiles } from '../strapi';
import { useState, useEffect } from 'react';
import Download from '@mui/icons-material/SimCardDownload';
import Paper from '@mui/material/Paper';

function Company({ content, content_, locale }) {
    const API_URL = process.env.REACT_APP_STRAPI_URL || 'http://81.31.246.97:1337';
    const [docs, setDocs] = useState([])
    useEffect(() => {
        fetchCompanyFiles(locale)
            .then(data => {
                setDocs(data);
            })
            .catch(err => {
            });
    }, [locale]);

    const onButtonClick = (url, name) => {
        const link = document.createElement("a");
        link.href = url;
        link.download = name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <div >
            <Container>
                <Typography gutterBottom variant="h4" component="div" className='block_title'>
                    {content?.title || ''}
                </Typography>
                <Typography className='mainText' component="div">
                    <Markdown>{content?.text || ''}</Markdown>
                </Typography>
            </Container>

            <Box sx={{ bgcolor: '#E1EEFF', pt: '100px', mt: '100px', mb: '50px', justifyContent: { xs: 'center', md: 'start' } }} >
                <Container>
                    <Typography gutterBottom sx={{ fontSize: {xs: '24px', md: '36px'}, fontWeight: 'bold', lineHeight: {xs: '30px', md: '50px'}, mb: 2, }} component="span">
                        {content_?.title+' ' || ''}
                    </Typography>
                    <Typography gutterBottom sx={{ fontSize: {xs: '24px', md: '36px'}, fontWeight: 'bold', lineHeight: {xs: '30px', md: '50px'}, mb: 2, }} component="span" color='#2D5B96'>
                        {(content_?.someText?.[0]?.body) || ''}
                    </Typography>
                    <Typography className='mainText' component="div">
                        <Markdown>{content_?.text || ''}</Markdown>
                    </Typography>
                    <AliceCarousel controlsStrategy="responsive, alternate" responsive={{
                        0: {
                            items: 1,
                        },
                        780: {
                            items: 3,
                            itemsFit: 'contain',
                        },
                        1280: {
                            items: 4,
                            itemsFit: 'contain',
                        },
                    }}                    
                    renderPrevButton={({ isDisabled }) => (
                        <span
                            style={{
                                position: 'absolute',
                                left: -40,
                                top: '50%',
                                transform: 'translateY(-50%)',
                                color: '#2D5B96',
                                border: 'none',
                                borderRadius: '50%',
                                width: 40,
                                height: 40,
                                zIndex: 2,
                                cursor: isDisabled ? 'not-allowed' : 'pointer',
                                opacity: isDisabled ? 0.5 : 1,
                                fontSize: 40,
                                fontWeight: 'bold',
                                outline: 'none',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                            disabled={isDisabled}
                            aria-label="previous"
                        >&#8592;</span>
                    )}
                    renderNextButton={({ isDisabled }) => (
                        <span
                            style={{
                                position: 'absolute',
                                right: -40,
                                top: '50%',
                                transform: 'translateY(-50%)',
                                color: '#2D5B96',
                                border: 'none',
                                borderRadius: '50%',
                                width: 40,
                                height: 40,
                                zIndex: 2,
                                cursor: isDisabled ? 'not-allowed' : 'pointer',
                                opacity: isDisabled ? 0.5 : 1,
                                fontSize: 40,
                                fontWeight: 'bold',
                                outline: 'none',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center', 
                            }}
                            disabled={isDisabled}
                            aria-label="next"
                        >&#8594;</span>
                    )}
                    style={{ position: 'relative', padding: '0 80px' }}
                >
                        {docs && docs.length > 0 && docs.map((item, index) =>
                            <Paper key={index} sx={{ m: '35px', p: '30px', textAlign: 'center' }} onClick={() => onButtonClick(API_URL + (item.pdf?.url || ''), item.name || '')}>
                                <Typography sx={{ mb: '35px', textAlign: 'center' }} gutterBottom variant="body1" component="div">
                                    {item.title || ''}
                                </Typography>
                                <Download sx={{ fontSize: '100px', color: '#2D5B96' }}></Download>
                            </Paper>
                        )}
                    </AliceCarousel>
                </Container>
            </Box>
            <Container>
                <Typography className='mainText' component="div">
                    {(content?.someText?.[0]?.body) || ''}
                </Typography>
            </Container>
        </div>
    );
}
export default Company;
